module.exports = __webpack_public_path__ + "img/manage.92b5ccae.svg";